module.exports = __webpack_public_path__ + "static/media/logo.86e11caa.png";